import React from 'react';
import PropTypes from 'prop-types';
import UserResultSelectedItem from './userResultSelectedItem';
import UserResultsHolder from './userResultsHolder';
import debounce from '../../utils/debounce';

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.userSearch = this.userSearch.bind(this);
    this.debouncedUserSearch = debounce(this.userSearch, 400);
    this.handleOnPaste = this.handleOnPaste.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  userSearch(event) {
    this.props.userSearch(this.props.searchUrl, event);
  }

  /*
  Debounces user input that doesn't match the listed
  character codes, this prevents the user search API
  from being hammered with requests on every keystroke
  */
  handleKeyDown(event) {
    event.persist();
    const noDebounceKeyCodes = [
      8,
      9,
      13,
      16,
      17,
      18,
      27,
      30,
      37,
      38,
      39,
      40,
      186,
      188,
    ];

    if (noDebounceKeyCodes.includes(event.keyCode)) {
      this.userSearch(event);
    } else {
      this.debouncedUserSearch(event);
    }
  }

  handleOnPaste() {
    setTimeout(() => {
      this.props.expandTextArea();
      this.props.checkForAndAddUser();
      this.props.updateAutoCompleteTextAreaValue('');
    }, 0);
  }

  handleChange(event) {
    this.props.updateAutoCompleteTextAreaValue(event.target.value);
  }

  render() {
    let selectedUsers;

    if (this.props.selectedUsers && this.props.selectedUsers.length > 0) {
      let index = -1;
      selectedUsers = this.props.selectedUsers.map(user => {
        index += 1;
        return (
          <UserResultSelectedItem
            key={user.key}
            user={user}
            color={this.props.color}
            index={index}
            removeSelectedUserClick={this.props.removeSelectedUserClick}
          />
        );
      });
    }

    return (
      <div>
        <ul className="user-selections">
          {selectedUsers}
          <li className="user-original">
            <textarea
              name="coworkers"
              className={this.props.error ? 'invalid' : null}
              style={{ height: this.props.inputAreaHeight }}
              onChange={event => this.handleChange(event)}
              onKeyDown={event => this.handleKeyDown(event)}
              onPaste={this.handleOnPaste}
              onBlur={event => this.props.checkForAndAddUser(event)}
              placeholder={this.props.translations.email}
              value={this.props.autoCompleteTextAreaValue}
              required
            />
          </li>
        </ul>
        {this.props.userSearchInView && (
          <UserResultsHolder
            translations={this.props.translations}
            color={this.props.color}
            userSearchResults={this.props.userSearchResults}
            userSearchResultsHeight={this.props.userSearchResultsHeight}
            userSearchStatus={this.props.userSearchStatus}
            userResultClick={this.props.userResultClick}
            hoverSelectedUserIndex={this.props.hoverSelectedUserIndex}
            changeHoverSelectedUser={this.props.changeHoverSelectedUser}
          />
        )}
      </div>
    );
  }
}

AutoComplete.propTypes = {
  changeHoverSelectedUser: PropTypes.func,
  checkForAndAddUser: PropTypes.func,
  color: PropTypes.string,
  error: PropTypes.string.isRequired,
  hoverSelectedUserIndex: PropTypes.number.isRequired,
  inputAreaHeight: PropTypes.string.isRequired,
  removeSelectedUserClick: PropTypes.func,
  searchUrl: PropTypes.string.isRequired,
  selectedUsers: PropTypes.array.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  userResultClick: PropTypes.func,
  userSearch: PropTypes.func.isRequired,
  userSearchInView: PropTypes.bool.isRequired,
  userSearchResults: PropTypes.array.isRequired,
  userSearchResultsHeight: PropTypes.string,
  userSearchStatus: PropTypes.string,
  expandTextArea: PropTypes.func,
  updateAutoCompleteTextAreaValue: PropTypes.func,
  autoCompleteTextAreaValue: PropTypes.string,
};

AutoComplete.defaultProps = {
  changeHoverSelectedUser: () => {},
  checkForAndAddUser: () => {},
  color: '',
  removeSelectedUserClick: () => {},
  userResultClick: () => {},
  userSearchResultsHeight: '',
  userSearchStatus: '',
  expandTextArea: () => {},
  updateAutoCompleteTextAreaValue: () => {},
  autoCompleteTextAreaValue: null,
};

export default AutoComplete;
